import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import RadioGroupControl from './radio-group-control';

const RadioGroupField = ({ name, ...controlProps }) => {
  return (
    <Field name={name}>
      {({ field, form }) => (
        <div>
          <RadioGroupControl
            name={name}
            form={form}
            {...controlProps}
            {...field}
          />
        </div>
      )}
    </Field>
  );
}

RadioGroupField.propTypes = {
  name: PropTypes.string
};

export default RadioGroupField;
